<script lang="ts">
    import {Component, Vue} from 'vue-facing-decorator'

    @Component
    export class FakeTemplatesMixin extends Vue {
        fakeTemplates = []

        async loadFakeTemplates() {
            const htmlTemplates = await Promise.all([
                this.$axios.$get('/htmlTemplate/client_invoice_pdf.html'),
                this.$axios.$get('/htmlTemplate/agent_invoice_pdf.html'),
                this.$axios.$get('/htmlTemplate/quotation_pdf.html'),
            ])
            this.fakeTemplates = [
                {
                    id: 4065343,
                    htmlTemplate: htmlTemplates[0],
                    documentType: 'Client Invoice',
                    templateLocales: ['en'],
                    active: true,
                    documentVisibility: ['TOUR_OPERATOR_1LEVEL'],
                },
                {
                    id: 4065344,
                    htmlTemplate: htmlTemplates[1],
                    documentType: 'Agent Invoice',
                    templateLocales: ['en'],
                    active: true,
                    documentVisibility: ['TOUR_OPERATOR_1LEVEL'],
                },
                {
                    id: 4065342,
                    htmlTemplate: htmlTemplates[2],
                    documentType: 'Quotation',
                    templateLocales: ['en'],
                    active: true,
                    documentVisibility: ['TOUR_OPERATOR_1LEVEL'],
                },
            ]
        }
    }

    export default FakeTemplatesMixin
</script>
